export const assetStates = {
    online: 7,
    offline: 9
}